import React from 'react';

// Import Pages
import Header from './Header';
import Home from './pages/Home';
import ProjectsPage from './pages/ProjectsPage';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import Footer from './pages/Footer';

const App = () => {
    
    return (
      <>
        <Header />
        <Home />
        <ProjectsPage />
        <Blog />
        <Contact />
        <Footer />
      </>
    );
};

export default App;